import { render, staticRenderFns } from "./company-news.vue?vue&type=template&id=e5c78f3e&scoped=true"
import script from "./company-news.vue?vue&type=script&lang=js"
export * from "./company-news.vue?vue&type=script&lang=js"
import style0 from "./company-news.vue?vue&type=style&index=0&id=e5c78f3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c78f3e",
  null
  
)

export default component.exports